import { useCallback, useEffect, useState } from "react";
import { useUsersApi } from "../api/usersApi";

export function useUserPerformance(days = 30) {
  const api = useUsersApi();
  const [performance, setPerformance] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchPerformance = useCallback(async () => {
    try {
      setLoading(true);
      const data = await api.getPerformance(days);
      setPerformance(data);
      setError(null);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [api, days]);

  useEffect(() => {
    fetchPerformance();
  }, [fetchPerformance]);

  return { performance, loading, error, refetch: fetchPerformance };
}
